import { Link } from 'react-router-dom';
import { UploadArrow } from '@shared/assets';
import st from './styles.module.scss';

interface Props {
  onAdd: () => void;
}

export const AddPromoBtn: React.FC<Props> = ({ onAdd }) => {
  return (
    <Link to="promo-edit/new" state={{ wasSelecting: true }} className={st.loadBtn} onClick={onAdd}>
      <span className={st.loadBtn__icon}>
        <UploadArrow />
      </span>
      Загрузить
    </Link>
  );
};
